import styles from './ExternalMedia.scss';

import debounce from 'lodash/debounce';
import React from 'react';

import { MediaFields, MediaSourceType } from 'src/api/contentful/contentTypes.cloverdotcom';
import { withBrowser } from '../Responsive/WithBrowser';
import { getPlayerHeight, getPlayerWidth } from './utils';

export const BASE_VIMEO_URL = 'https://player.vimeo.com/video';

export interface IframeVideoProps extends React.AllHTMLAttributes<HTMLElement> {
  mediaFields?: MediaFields;
  isMobile?: boolean;
  isTablet?: boolean;
  onEnd?: () => void;
}

class IframeVideo extends React.Component<IframeVideoProps> {
  onResize = debounce(() => {
    this.forceUpdate();
  });

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  render() {
    const { isMobile, isTablet, mediaFields } = this.props;
    const { internalName = 'iframe-vimeo', source = '', sourceType = '' } = mediaFields || {};
    const vimeoUrl = `${BASE_VIMEO_URL}/${source}?autoplay=false`;
    const iframeSrc = sourceType === MediaSourceType.VIMEO ? vimeoUrl : '';

    if (!source || !iframeSrc) return null;

    const viewportWidth = (window.innerWidth);
    const playerWidth = getPlayerWidth(viewportWidth, isMobile, isTablet);
    const playerHeight = getPlayerHeight(playerWidth);

    return (
      <iframe
        className={styles.videoContainer}
        title={internalName}
        src={iframeSrc}
        style={{ width: `${playerWidth.toString()}px`, height: `${playerHeight.toString()}px` }}
        allow="autoplay"
        allowFullScreen
        data-ready="true"
        frameBorder={0}
      />
    );
  }
}

const Browsered = withBrowser(browser => ({
  isMobile: browser.is.mobile,
  isTablet: browser.is.tablet,
}))(IframeVideo);
type Browsered = typeof Browsered;

export {
  Browsered as IframeVideo,
  IframeVideo as _IframeVideo,
};
